import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui';
import { useUserConnected } from '@/hooks';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import routes from '@/lib/routes';

interface IMenu {
  title: string;
  href: string;
  rootOnly?: boolean;
  permission?: AdminUserPermissionsEnum;
}

const MENUS: IMenu[] = [
  { title: 'Permissions', href: routes.nav.settings.permissions.path.toLowerCase() },
  { title: 'Outils', href: routes.nav.settings.tools.path.toLowerCase() },
  { title: 'Paiements', href: routes.nav.settings.paymentProviders.path.toLowerCase(), permission: AdminUserPermissionsEnum.PAYMENT_PROVIDERS },
  { title: 'Forfaits', href: routes.nav.settings.paymentPackages.path.toLowerCase(), permission: AdminUserPermissionsEnum.PAYMENT_PACKAGES },
  { title: 'Demandes paiement', href: routes.nav.settings.paymentMethodRequests.path.toLowerCase(), permission: AdminUserPermissionsEnum.PAYMENT_METHOD_REQUESTS },
  { title: "Journaux d'audit", href: routes.nav.settings.auditLogs.path.toLowerCase(), rootOnly: true }
];

const Menus = () => {

  const { pathname } = useLocation();
  const { userConnected, hasPermissions } = useUserConnected();
  const isRoot = !!userConnected?.root;

  return (
    <aside className='md:w-1/5'>
      <nav className='flex space-x-2 md:flex-col md:space-x-0 md:space-y-1'>
        {
          MENUS
            .filter(l => !l.rootOnly || isRoot)
            .filter(l => !l.permission || isRoot || hasPermissions(l.permission))
            .map(
              l => (
                <Link replace key={l.href} to={l.href}>
                  <Button
                    className='justify-start w-full'
                    variant={
                      l.href === pathname.toLowerCase().split('/').reverse()[0]
                        ? 'secondary'
                        : 'link'
                    }
                    size={'sm'}>
                    {l.title}
                  </Button>
                </Link>
              )
            )
        }
      </nav>
    </aside>
  );

};

export default Menus;
